export const getHeadingText = (detailview) => {
  const headings = {
    MQTT: "MQTT",
    JAVA: "Java Server",
    Camera: "Camera",
    PC: "PC",
    UPS: "UPS",
    "Strobes & Speakers": "Strobes & Speakers",
    "Push Button": "Push Buttons",
    JACE: "JACE",
    PepLink: "PepLink",
    Panel: "Panel",
    DMP: "DMP",
  };

  return headings[detailview] || "System Health Status";
};

export const getScreenReaderText = (detailview, headingText) => {
  return detailview === 0
    ? "Screen changed to System Health Status"
    : `Screen changed to ${headingText} details view`;
};

export const formatDetailedViewData = (type, value) => {
  switch (type.toLowerCase()) {
    case "ups": {
      const {
        battery_runtime,
        battery_charge,
        input_voltage,
        battery_voltage,
        operating_mode,
        load_percent,
      } = value;
      return {
        Runtime: `${battery_runtime} seconds`,
        "Charge Level": `${battery_charge} %`,
        "Input Voltage": `${input_voltage} v`,
        "Battery Voltage": `${battery_voltage} v`,
        "Operating Mode": operating_mode,
        "Load Percent": `${load_percent} %`,
      };
    }

    case "pc": {
      const { cpuUsage, diskUsage, memoryUsage } = value;
      return {
        "CPU Usage": `${cpuUsage} %`,
        "Disk Usage": `${diskUsage} %`,
        "Memory Usage": `${memoryUsage} %`,
      };
    }

    case "java": {
      const {
        cpuUsage,
        freePhysicalMemory,
        heapMemoryUsed,
        nonHeapMemoryUsed,
        totalPhysicalMemory,
        health,
      } = value;
      return {
        "CPU Usage": cpuUsage,
        Health: health ? "true" : "false",
        "Free Physical Memory": `${(freePhysicalMemory / (1024 * 1024)).toFixed(
          2
        )} MB`,
        "Heap Memory": `${(heapMemoryUsed / (1024 * 1024)).toFixed(2)} MB`,
        "Non Heap Memory": `${(nonHeapMemoryUsed / (1024 * 1024)).toFixed(
          2
        )} MB`,
        "Total Physical Memory": `${(totalPhysicalMemory / (1024 * 1024)).toFixed(
          2
        )} MB`,
      };
    }

    case "peplink": {
      const {
        wan,
        health,
        deviceCpuLoad,
        deviceTotalMemory,
        connectionType,
        deviceFirmwareVersion,
        deviceSystemUpTime,
        topic,
        deviceModel,
        deviceMemoryUsage,
      } = value;
      return {
        WAN: wan,
        Health: health ? "true" : "false",
        "Device CPU Load": deviceCpuLoad,
        "Device Total Memory": deviceTotalMemory,
        "Connection Type": connectionType,
        "Device Firmware Version": deviceFirmwareVersion,
        "Device System Up Time": deviceSystemUpTime,
        Topic: topic,
        "Device Model": deviceModel,
        "Device Memory Usage": deviceMemoryUsage,
      };
    }

    case "panel": {
      const { humidity, temperature } = value;
      return {
        Humidity: `${humidity} %`,
        Temperature: `${temperature} °C`,
      };
    }

    default:
      return {};
  }
};

export const parseDeviceHealth = (parsedMessage) => {
  const healthData = {};
  Object.entries(parsedMessage).forEach(([key, value]) => {
    healthData[key] = value.health ? "healthy" : "critical";
  });
  return healthData;
};

export const handleCameraKey = (key) => {
  if (key.includes("camera")) return "Camera";
  if (key.includes("ecc")) return "ECC";
  if (key.includes("ups")) return "UPS";
  return key;
};


export const handleDMPData = (value, identity, additonalText, setDmpData, setECCData, setPepLinkData) => {
  if (!Array.isArray(value)) return "critical";

  const parsed = value.map((d) => JSON.parse(d.data));
  const formatted = parsed.flatMap((obj) =>
    Object.values(obj).map((item) => ({
      name: item.name,
      health: item.health ? "true" : "false",
    }))
  );
  if (
    additonalText.toLowerCase() !== "dmp" &&
    additonalText.toLowerCase() !== "strobes & speakers" &&
    additonalText.toLowerCase() !== "peplink"
  ) {

    if (identity === "DMP") {
      setDmpData(formatted);
    } else if(identity.toLowerCase() === "ecc") {
      setECCData(formatted);
    } else if(identity.toLowerCase() === "peplink") setPepLinkData(formatted);
  }

  const result = parsed
    .flatMap((obj) => Object.values(obj).map((item) => item.health))
    .every((v) => v);

  return result ? "healthy" : "critical";
};

 const handleCameraData = (value, key) => {
    if (value.data)
      return JSON.parse(value.data)[key]?.health ? "healthy" : "critical";
    else return "critical";
  };


export const computeHealthFromData = (
        data,
        cameraData,
        additonalText,
        setDmpData,
        setECCData,
        setPepLinkData
      ) => {
  const healthData = {};
  Object.entries(data).forEach(([key, value]) => {
    if (key.toLowerCase() === "pushbutton") {
      healthData["Push Button"] = !JSON.parse(value.data).status
        ? "critical"
        : "healthy";
    } 
    else if (key.toLowerCase() === "dmp") {
      healthData[key] = handleDMPData(value, "DMP", additonalText, setDmpData, setECCData, setPepLinkData);
    } else if (key.toLowerCase() === "ecc") {
      healthData["Strobes & Speakers"] = handleDMPData(value, "ECC", additonalText, setDmpData, setECCData, setPepLinkData);
    } else if(key.toLowerCase() === "peplink") {
      healthData["PepLink"] = handleDMPData(value, "Peplink", additonalText, setDmpData, setECCData, setPepLinkData);
    }
    else if (value.data) {
      const parsed = JSON.parse(value.data);
      if (key.toLowerCase() === "ups") {
        healthData["UPS"] =
          parsed[Object.keys(parsed)[0]]["operating_mode"].includes("mains")
            ? "healthy"
            : "critical";
      } else if (key.toLowerCase() === "jace") {
        healthData["JACE"] =
          parsed[Object.keys(parsed)[0]].health ? "healthy" : "critical";
      } else if (key.toLowerCase() === "camera") {
        healthData["Camera"] = !parsed.status ? "critical" : "healthy";
      } else if (key.toLowerCase() === "panel") {
        healthData["Panel"] = parsed.PANEL.health ? "healthy" : "critical";
      } else {
           healthData[key.toLowerCase() ==="panel" ? "Panel" :
              key.toLowerCase() === "ecc"
                ? "Strobes & Speakers"
                : key.toLowerCase() === "peplink"
                ? "PepLink"
                : key
            ] = key.includes("camera")
              ? "healthy"
              : handleCameraData(value, key);
          }
        }

  });
  return healthData;
};

export const mapDetailViewToText = (detailview) => {
  const mapping = {
    "Push Button": "pushbuttons",
    PC: "PC",
    UPS: "UPS",
    Camera: "Camera",
    JACE: "JACE",
    JAVA: "JAVA",
    PepLink: "PepLink",
    MQTT: "MQTT",
    "Strobes & Speakers": "Strobes & Speakers",
    Panel: "Panel",
    DMP: "DMP"
  };
  return mapping[detailview] || "";
};
